import React from "react"
import { useTranslation } from "react-i18next"

import CustomTooltip from "pages/parts/CustomTooltip"

/**
 * Иконка «?» с расшифровкой метрики.
 *
 * Половина слов на дашборде — жаргон: MRR, GTV, ARPA, take rate. Без расшифровки
 * страницу читает только тот, кто её заказал. Тексты лежат в переводах (ru.json),
 * а не в компонентах: тот же словарь идёт в выгрузку, чтобы инвестор читал те же
 * формулы, что видит на экране. Остальные языки подхватывают русский по fallbackLng.
 */
function MetricHint({ hintKey }) {
	const { t } = useTranslation()

	if (!hintKey) return null

	const text = t(hintKey)
	// Ключа в переводах нет — молча ничего не рисуем, а не показываем сам ключ.
	if (!text || text === hintKey) return null

	return (
		<CustomTooltip text={text}>
			<i
				className="uil-question-circle"
				style={{ fontSize: "13px", color: "#b6bec9", cursor: "help" }}
			></i>
		</CustomTooltip>
	)
}

export default MetricHint
